import { Injectable } from "@angular/core";
import { Floor } from "src/app/app/building/floor/floor.model";
import { DictionaryValues } from "src/app/dictionary";
import { SpaceFilter } from "../space-filter/space-filter.model";

@Injectable({
  providedIn: "root",
})
export class SpaceDateFilterService {
  filterType: string;
  firstNameLastName: string;
  additionalContent: string;
  subtype: DictionaryValues;
  buildingListId: number[] = [];
  floorId: string;

  hour: number;
  minute: number;

  filterLoadedFloors: Floor[] = [];
  filterDetails: SpaceFilter;

  filterModalFirstLoad: boolean = true;

  setTimeToReservation: boolean = false;
  setTimeForHowLongReservation: boolean = false;
  guestSelected = false;
  filtering: boolean = false;
}
